'use strict';

define('vb/action/builtin/fireAiRequestEventAction',['vb/action/action', 'vb/private/log', 'vb/private/stateManagement/application',
  'vb/private/utils'],
(Action, Log, Application, Utils) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  const logger = Log.getLogger('/vb/action/builtin/fireAiRequestEventAction');

  /**
   * Fires an AI request event on the application's event bus.
   *
   * @extends {Action}
   * @category Action
   */
  class FireAiRequestEventAction extends Action {
    /**
     * Performs the action of firing an AI request event on the application's event bus.
     *
     * @async
     * @param {Object} parameters - The parameters object containing the event details.
     * @param {Object} parameters.payload - The payload associated with the event.
     * @param {string} [parameters.event]  - The name of the event to fire. This is used by the Actions api.
     * @returns {Promise<Outcome>} A promise resolving to an outcome indicating success or failure.
     */
    async perform(parameters) {
      const {
        payload,
        event,
      } = parameters;

      // to prevent event handlers from making unpredictable changes, pass by value instead of by reference. Event
      // payloads are meant to be serializable any way and must not hold references to state that may not survive
      // the event processing lifecycle
      let clonePayload = payload;
      if (payload) {
        clonePayload = Utils.cloneObject(payload);
      }

      logger.info('FireAiRequestEventAction', this.logLabel, 'with event name', event,
        'and payload', clonePayload);

      try {
        const result = await Application.aiEventBus
          .fireAiRequestEvent(payload, event);
        return Action.createSuccessOutcome(result);
      } catch (error) {
        return Action.createFailureOutcome(error.message, error);
      }
    }
  }

  return FireAiRequestEventAction;
});

